import theme from '../theme'
import makeStyles from '../makeStyles'

export const styles = makeStyles({
  success: {
    background: theme.palette.success.light + ' !important',
    boxShadow: 'none',
    border: '1.4px solid #1e8d47',
    marginBottom: '15px',
    color:  theme.palette.success.secondary + ' !important',
    '& .MuiSvgIcon-root': {
      color: theme.palette.success.main,
    },
  },
  error: {
    marginBottom: '15px',
    boxShadow: 'none',
    background: theme.palette.error.light + ' !important',
    border: '1.4px solid #eb0043',
    color:  theme.palette.error.secondary + ' !important',
    '& .MuiSvgIcon-root': {
      color: theme.palette.error.main,
    },
  },
  info: {
    boxShadow: 'none',
    border: '1.4px solid #5b73ba',
    background: theme.palette.info.light + ' !important',
    color:  theme.palette.info.secondary + ' !important',
    marginBottom: '15px',
    '& .MuiSvgIcon-root': {
      color: theme.palette.info.main,
    },
  },
  warning: {
    marginBottom: '15px',
    boxShadow: 'none',
    background: theme.palette.warning.light + ' !important',
    color:  theme.palette.warning.secondary + ' !important',
    border: '1.4px solid #fc0',
    '& .MuiSvgIcon-root': {
      color: theme.palette.warning.main,
    },
  },
  message: {
    width: '100%',
    textAlign: 'center',
  },
  root: {
    width: '100%',
    padding: '2px 10px 2px 10px',
    lineHeight: '28px',
  },
  icon: {
    marginRight: '0px',
  },
  closeIcon: {
    '& svg': {
      marginTop: '0px',
      '& path': {
        stroke: 'none',
      },
    },
  },
})
